import instance from './DefaultApi';

export default class ProductService {
    ControllerName = 'Product';

    // get all products
    GetProducts(tableRequest) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetProducts`, tableRequest).then(res => res)
    }
    // create new product and update existing product 

    CreateUpdateProduct(productData) {
        debugger
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/CreateUpdateProduct`, productData).then(res => res)
    }
    // delete product
    DeleteProduct(productId) {
        return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/DeleteProduct/${productId}`).then(res => res)
    }
    // get all products for ddl 
    GetProductsDDL() {
        return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetProductsDDL`).then(res => res)
    }

    GetProductsDDLSearch(search) {
        return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetProductsDDLSearch?search=${search}`).then(res => res)
    }

    GetMappingdetailonproductcode(formData) {
        debugger;
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetMappingDetailFromSAP`, formData).then(res => res)
    }
    GetProcessCreatedDateOnPlant(formData) {
        debugger;
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/SAPCreatedDateonPlant`, formData).then(res => res)
    }
    FilterSapDataByCreatedDate(formData) {
        debugger;
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/SAPCreatedDateonPlantfilterdatewise`, formData).then(res => res)
    }
    FilterSapDataByProcessOrder(formData) {
        debugger;
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/SAPDataonfilterProcessorderwise`, formData).then(res => res)
    }

    //Get Mapped Products Drop Down  
    GetMappedProductsDDL() {
        return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetMappedProductsDDL`).then(res => res)
    }

    // GetMapProductsDDLBySelection WareHouse or User
    GetMapProductsDDLBySelectionWU(req) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetMapProductsDDLBySelectionWU`, req).then(res => res)
    }
    ProductCSVUpload(data) {
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/ProductCSVUpload`, data).then(res => res)
    }
    getProductCd(productId) {
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/getProductCd/${productId}`).then(result => result)
    }
    GetBatchNoProcessOrder(productId) {
        debugger
        return instance.get(`${process.env.REACT_APP_API_URL}${this.ControllerName}/GetBatchNoProcessOrder/${productId}`).then(res => res)
    }
    insertproductsapdata() {
        debugger
        return instance.post(`${process.env.REACT_APP_API_URL}${this.ControllerName}/InsertSAPdata`).then(res => res)
    }

}